// extracted by mini-css-extract-plugin
export var app = "e_G_b2";
export var appReset = "e_G_b1";
export var appWhiteSpace = "e_G_b3";